import { User } from "../_interface/user";


export const chartColorScheme = [
  "#25CCF7", "#FD7272", "#54a0ff", "#00d2d3",
  "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e",
  "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
  "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6",
  "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d",
  "#55efc4", "#81ecec", "#74b9ff", "#a29bfe", "#dfe6e9",
  "#00b894", "#00cec9", "#0984e3", "#6c5ce7", "#ffeaa7",
  "#fab1a0", "#ff7675", "#fd79a8", "#fdcb6e", "#e17055",
  "#d63031", "#feca57", "#5f27cd", "#54a0ff", "#01a3a4"
];

export const hexToRgba = (hex: string, alpha: number) => {
  // Uklanja "#" ako postoji
  hex = hex.replace(/^#/, '');

  // Parsiranje boje u R, G, B
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Vraća u "rgba(R, G, B, A)" formatu
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const getDayName = (dayNumber: number, locale = 'sr-RS', format: 'long' | 'short' = 'long') => {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: format });
  const referenceDate = new Date(2024, 0, 7 + dayNumber); // 7. januar 2024. je nedelja (0)
  return formatter.format(referenceDate);
};

export const getMonthName = (monthNumber: number, locale = 'sr-RS', format: 'long' | 'short' = 'long') => {
  const formatter = new Intl.DateTimeFormat(locale, { month: format });
  const referenceDate = new Date(2024, monthNumber - 1, 1);
  return formatter.format(referenceDate);
};


export const mapJsonToUsers = (jsonItems: User[] | null): User[] => {
  const list: User[] = [];
  jsonItems?.forEach(u => {
    const newUser = {} as User;
    Object.assign(newUser, u);
    list.push(newUser);
  });
  return list;
};


export const toLocalDateJsonString = (date: Date) => {
  if (!date) {
    return null;
  }

  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T' +
    ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2);
};

export const parseToLocalDate = (date: string | Date | null) => {
  if (!date) {
    return null;
  }

  // var s = '2011-06-21T14:27:28.593Z';
  const a = date.toString().split(/[^0-9]/).map(i => parseInt(i, 10));

  const d = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
  return d;
};
